import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import withStyles from '@mui/styles/withStyles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const styles = (theme) => ({
  root: {
    '& div': {
      zIndex: 4,
    },
  },
  paper: {
    marginRight: theme.spacing(2),
    backgroundColor: 'white',
  },
});

class KDropdownMultiMenu extends React.Component {
  state = {
    showMenu: false,
  };

  toggleMenuVisibility = () => {
    this.setState((state) => ({ showMenu: !state.showMenu }));
  };

  handleClose = (event) => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ showMenu: false });
  };

  render() {
    const { classes, label, items } = this.props;
    const { showMenu } = this.state;

    return (
      <div className={classes.root}>
        <Button
          variant="contained"
          color="primary"
          className={classes.margin}
          buttonRef={(node) => {
            this.anchorEl = node;
          }}
          onClick={this.toggleMenuVisibility}
        >
          {label}
          {showMenu ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </Button>

        <Popper open={showMenu} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <ClickAwayListener onClickAway={this.handleClose}>
                <Paper className={classes.paper}>
                  <LocalMenuList items={items} />
                </Paper>
              </ClickAwayListener>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

KDropdownMultiMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

const LocalMenuList = ({ items }) => {
  return (
    <MenuList>
      {items.map((item) => (
        <MenuItem key={item.name}>
          <FormControlLabel
            control={<Checkbox checked={item.checked} onChange={item.toggleFunc} value={item.name} color="primary" />}
            label={item.label}
          />
        </MenuItem>
      ))}
    </MenuList>
  );
};

export default withStyles(styles)(KDropdownMultiMenu);
